export const centerDiv = {
  display: "flex",
  justifyContent: "center",
  alignItems: "center",
};
